import React, { Component, Fragment } from "react";
import VerificationCode from "../../components/verificationCode";
import GeneralButton from "../../components/generalButton";
import check from "../../static/images/check.png";
import Bounced from "../../components/bounced";
import { verificationCodeInfo } from "../../services/interfaceType";
import { spCheck, spGetConfig } from "../../services/services";
import { getQueryString, compare } from "../../utils/utils";
import { burying } from "../../utils/buryPoint";
import { message } from "antd";
import { spGetConfigType } from "../../services/interfaceType";
import Confirmation from "../../components/confirmation";
import AppealEntrance from "../appealentrance";
import styles from "./index.less";

interface Props {
  history: any;
}

interface State {
  phoneValue: string; //手机Input
  codeValue: string; //验证码Input
  grayscaleType: boolean; //按钮置灰
  validationStatus: boolean;
  templateData: any;
  promptMessage: string; // 未登录状态用户检验返回信息
  userType: any;
  enterpriseType: any;
  customField: any;
  selectType: boolean;
  checkedId: any;
  selectValue: string;
  codeError?: string;
  phoneError?: string;
  bouncedData: string;
  caseType:string;
}

class Appealspentrance extends Component<Props, State> {
  phoneInfo: verificationCodeInfo; //手机号配置
  codeInfo: verificationCodeInfo; //验证码配置
  constructor(props: Props) {
    super(props);
    this.state = {
      phoneValue: "",
      codeValue: "",
      grayscaleType: true,
      validationStatus: true,
      templateData: [],
      promptMessage: "",
      userType: {},
      caseType:"",
      enterpriseType: {},
      customField: {},
      selectType: false,
      checkedId: "",
      selectValue: "",
      codeError: "",
      phoneError: "",
      bouncedData: "",
    };
  }
  async componentDidMount(){
    if(getQueryString('from')=="erAppeal"){
      await this.setState({
        validationStatus: false,
        enterpriseType:null,
        customField:null,
      });
      const param = {
        spTemplateId: getQueryString('spTemplateId'),
      };
     this.spGetConfig(param);
    }
  }
  componentWillMount() {
    this.phoneInfo = {
      showName: "账号",
      required: true,
      showTips: "请输入手机号",
      showOrder: 1,
      maxSize: 11,
      type: 1,
    };
    this.codeInfo = {
      showName: "验证码",
      required: true,
      showTips: "请输入验证码",
      showOrder: 1,
      maxSize: 6,
      type: 1,
    };
    burying(
      "1",
      "appeal-submit-page",
      "punishid=undefined",
      "ss-03",
      "undefined"
    );
  }

  //手机号输入的值
  onPhone = (value: string) => {
    if (value !== "") {
      this.setState({
        phoneError: "",
      });
    }
    this.setState({
      phoneValue: value,
      grayscaleType: false,
    });
  };

  //验证码输入的值
  onCode = (value: string) => {
    if (value !== "") {
      this.setState({
        codeError: "",
      });
    }
    this.setState({
      codeValue: value,
      grayscaleType: false,
    });
  };

  checkMessage = () => {
    this.setState({
      promptMessage: "",
    });
  };

  /**
   * @description 下一步
   *
   **/
  nextStep = async () => {
    const spTemplateId = getQueryString("spTemplateId");
    const { codeValue, phoneValue } = this.state;
    if (phoneValue !== "" && codeValue !== "") {
      const params = {
        spTemplateId: spTemplateId,
        phone: phoneValue,
        captcha: codeValue,
      };
      const result = await spCheck(params);
      if (result) {
        if (result.code === 0 && result.data.type ==1) {
          const { enterpriseType, customField } = result.data;
          await this.setState({
            enterpriseType,
            customField,
            validationStatus: false,
          });
          const param = {
            spTemplateId: spTemplateId,
            // userType: userType ? userType.id : "",
            // enterpriseType: enterpriseType ? enterpriseType.id : "",
            // customFieldValue: "",
          };
          customField ? "" : this.spGetConfig(param);
        }else if(result.code === 0 &&result.data.type ==2){
          const detailsUrl = `/case/home/detail/${result.data.caseId}?spTemplateId=${spTemplateId}&caseId=${result.data.caseId}`
          this.props.history.push(detailsUrl);
        } else if (result.code === 3) {
          await this.setState({
            promptMessage: result.msg,
            validationStatus: true,
          });
        }
      } else {
        this.props.history.push("/case/home/error");
      }
      burying("2", "nextstep-appeal-submit", "valid=1", "ss-03", "undefined");
    } else {
      if (phoneValue === "" && codeValue === "") {
        this.setState({ phoneError: " 请输入手机号" });
      } else {
        this.setState({ codeError: " 请输入验证码" });
      }
      burying("2", "nextstep-appeal-submit", "valid=0", "ss-03", "undefined");
    }
  };

  /**
   * @description 获取未登录状态全局配置
   *
   **/
  spGetConfig = async (params: spGetConfigType) => {
    const result = await spGetConfig(params);
    if (result) {
      if (result.code === 0) {
        if (this.state.templateData.length > 0) {
          this.setState({
            templateData: [],
          });
        }
        this.setState({
          templateData: result.data.widgets.sort(compare("showOrder")),
          userType:result.data.userType,
          caseType:result.data.caseType,
          enterpriseType:result.data.enterpriseType
        });
      } else {
        message.info(result.msg);
      }
    } else {
      this.props.history.push("/case/home/error");
    }
  };

  /**
   * @description 下拉列表选择
   *
   **/
  handleSelect = (id: string | number, selectValue: any) => {
    const { userType, enterpriseType } = this.state;
    const spTemplateId = getQueryString("spTemplateId");
    this.setState({
      checkedId: id,
      selectValue: selectValue.children,
      selectType: false,
    });
    const params = {
      spTemplateId: spTemplateId,
      userType: userType ? userType.id : "",
      enterpriseType: enterpriseType ? enterpriseType.id : "",
      customFieldValue: id,
    };
    this.spGetConfig(params);
    burying("2", "verify-appeal-submit", "frame=2", "ss-03", "undefined");
  };

  /**
   * @description 获取展示数据
   *
   **/
  getBouncedData = (bouncedData) => {
    this.setState({
      bouncedData,
    });
    document.body.scrollTop = 0;
  };

  render() {
    const {
      validationStatus,
      promptMessage,
      userType,
      enterpriseType,
      customField,
      phoneValue,
      codeValue,
      templateData,
      checkedId,
      phoneError,
      codeError,
      bouncedData,
      caseType
    } = this.state;
    const templateId = getQueryString("templateId");
    return (
      <Fragment>
        {bouncedData ? (
          <div className={styles.bounced}>
            <Bounced
              bouncedText={bouncedData}
              needImg={true}
              typeBounced="spentrance"
            />
          </div>
        ) : null}
        <div style={{ width: templateId === "2" ? "" : "815px" }}>
          <div className={styles.appealspentrance}>
            <div className={styles.appealspentranceTitle}>
              <span className={styles.title}>提交申诉</span>
            </div>
            {validationStatus ? (
              <div className={styles.verificationCode}>
                <div>
                  <div className={styles.title}>账号受限申诉需验证手机:</div>
                  <VerificationCode
                    is_required={true}
                    code={true}
                    onPhone={this.onPhone}
                    onCode={this.onCode}
                    phoneInfo={this.phoneInfo}
                    codeInfo={this.codeInfo}
                    phoneError={phoneError}
                    codeError={codeError}
                    checkMessage={this.checkMessage}
                    type="sp"
                  />
                  {promptMessage ? (
                    <div
                      className={styles.check}
                      style={{
                        color:
                          promptMessage == "该账户可以正常登录，无异常"
                            ? "#52c41a"
                            : "#ff5218",
                      }}
                    >
                      {promptMessage == "该账户可以正常登录，无异常" ? (
                        <img src={check} />
                      ) : null}
                      <div>{promptMessage}</div>
                    </div>
                  ) : null}
                </div>
              </div>
            ) : null}
            {!validationStatus ? (
              <div>
                <Confirmation
                  userType={userType}
                  enterpriseType={enterpriseType}
                  customField={customField}
                  phoneValue={phoneValue}
                  handleSelect={this.handleSelect}
                  caseType={caseType}
                />
              </div>
            ) : null}
            {templateData.length > 0 ? (
              <AppealEntrance
                configurationData={templateData}
                userTypeId={userType ? userType.id : ""}
                enterpriseType={enterpriseType ? enterpriseType.id : ""}
                customFieldValue={checkedId}
                getBouncedData={this.getBouncedData}
                type="spentrance"
                history={this.props.history}
              />
            ) : null}
            {validationStatus ? (
              <div className={styles.generalButton}>
                <GeneralButton
                  buttonText="下一步"
                  type="max"
                  styleColor="activation"
                  buttonClick={this.nextStep}
                  grayType={
                    phoneValue.length == 11 && codeValue.length == 6
                      ? false
                      : true
                  }
                />
              </div>
            ) : null}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default Appealspentrance;
